const montarQueryFiltro = (filtro_base: string) => {

    let primeiroOperador=retornePrimeiroSinalOperador(filtro_base);
    let segundoOperador = primeiroOperador === '&' ? '|' : '&';
     let arrayBase:any[] = filtro_base.split(primeiroOperador);
    let arrayRetorno:any[] = [];
    let index = 0;

       for(let i=0;i<arrayBase.length;i++) {

          if(arrayBase[i].includes(segundoOperador)){
            let tmp = arrayBase[i].split(segundoOperador);

            for(let a=0;a<tmp.length;a++) {
                if(tmp[a] && tmp[a].trim().length > 0){
                    arrayRetorno[index] ={operador: a===0 ? `${primeiroOperador}${primeiroOperador}` : `${segundoOperador}${segundoOperador}`, valor: tmp[a].toLocaleUpperCase().trim()} 
                    index++;
                }
            }
          }else{
            if(arrayBase[i] && arrayBase[i].trim().length > 0){
              arrayRetorno[index] ={operador: `${primeiroOperador}${primeiroOperador}`, valor: arrayBase[i].toLocaleUpperCase().trim()}
              index++;
            }            
          }
          
       }

    return arrayRetorno;
}

const retornePrimeiroSinalOperador = (filtro_base: string) => {
    let operadorAnd = filtro_base.indexOf('&');
    let operadorOr = filtro_base.indexOf('|');
    if((operadorAnd === -1)  && (operadorOr === -1)) return 'WXKLMNBERA';
    if((operadorOr !== -1) && ((operadorAnd === -1) || (operadorAnd > operadorOr))) return '|';
    if((operadorAnd !== -1) && ((operadorOr === -1) || (operadorAnd < operadorOr))) return '&';
    return 'WXKLMNBERU';
}

const isExisteOperadorAnrOr = (filtro_base: string) => {
    return (filtro_base.indexOf('&') !== -1) || (filtro_base.indexOf('|')  !== -1);
}

const montarLinhaParaFilter = (item:any, atributos:string[]) => {
    if(!atributos || atributos.length === 0) return JSON.stringify(item).toLocaleUpperCase();

    let retorno = item[atributos[0]];
    for (let i = 1; i < atributos.length; i++) {
        retorno = `${retorno} ${item[atributos[i]]}`;
    }

    return retorno;
}

const filtrar = (listaFiltrar: any[], attributosFilter:string[],filtro: string) => {
    let retorno: any[] = [];

    if (!isExisteOperadorAnrOr(filtro)) {
        retorno = listaFiltrar.filter((linha) => montarLinhaParaFilter(linha,attributosFilter).toLocaleUpperCase().includes(filtro.toLocaleUpperCase().trim()));
    } else {
        let quaryFilter: any[] = montarQueryFiltro(filtro);
   
        retorno = listaFiltrar.filter((linha) => {

            let linhaAvaliar = montarLinhaParaFilter(linha,attributosFilter).toLocaleUpperCase();
            let isOk = false;
           
            for (let i = 0; i < quaryFilter.length; i++) {
                isOk = linhaAvaliar.includes(quaryFilter[i].valor);
                if ((i < (quaryFilter.length - 1)) && quaryFilter[i + 1].operador.includes('||') && isOk) return isOk;  
            }
       
            return isOk;

        });
    }
    return retorno;
}

export {
    filtrar
}